import { evolve } from "@/icons";
import { cn } from "@/lib/utils";

interface EvolutionsButtonProps {
  disabled: boolean;
  active: boolean;
  onClick: () => void;
  small?: boolean;
}

export const EvolutionsButton = ({
  disabled,
  active,
  onClick,
  small,
}: EvolutionsButtonProps) => {
  return (
    <button
      className={cn(
        "h-9 py-1.5 px-3 text-evolution-secondary rounded text-sm flex flex-row items-center gap-2",
        disabled
          ? "text-dark-disabled bg-disabled cursor-not-allowed"
          : active
            ? "bg-evolution-active"
            : "bg-evolution-hover hover:bg-evolution-active",
        !disabled && "shadow-button",
      )}
      disabled={disabled}
      onClick={() => {
        if (!disabled) {
          onClick();
        }
      }}
    >
      {!small && <span>Evolve</span>}
      <div className="w-4 h-4">{evolve}</div>
    </button>
  );
};
